import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

interface StyledButtonProps {
  children: string | React.ReactNode;
  onClick?: () => void;
  className?: string;
  color?: string;
  id?: string;
  block?: boolean;
  outline?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

function StyledButton({
  children,
  onClick,
  className,
  color,
  id,
  block,
  outline,
  disabled,
  type,
}: StyledButtonProps) {
  return (
    <Button
      id={id}
      onClick={onClick}
      className={`styled-btn ${className}`}
      color={color}
      block={block}
      outline={outline}
      disabled={disabled}
      type={type}
    >
      <span className="styled-btn-text">{children}</span>
    </Button>
  );
}

StyledButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  color: PropTypes.string,
  id: PropTypes.string,
  block: PropTypes.bool,
  outline: PropTypes.bool,
  disabled: PropTypes.bool,
};

StyledButton.defaultProps = {
  onClick: () => {},
  className: '',
  color: 'primary',
  id: '',
  type: 'button',
  block: false,
  outline: false,
  disabled: false,
};
export default StyledButton;
